import { apiGetAuth, apiPostAuth, apiPutAuth } from '@/utils/api'
import { API_TERMS_CONDITION } from '@/utils/api-url'
import {
  notificationDanger
} from '@/utils/notification'

const state = {
  detail_terms_condition: { 
    isLoading: false,
    data: []
  },
  data_modal_add_edit: {},
  toggle_modal_add_edit_discard: {
    targetModals: false,  
    title: '',
    description: '',
    type: '',
    customTitleBtnOk: '',
    customTitleBtnCancel: '',
    customClass: '',
    loadingTable: false,
    loadingPopUp: false
  }
}

const mutations = {
  "SET_DETAIL_TERMS_CONDITION": (state, payload) => {
    state.detail_terms_condition = payload
  },
  "SET_DATA_MODAL_ADD_EDIT": (state, payload) => {
    state.data_modal_add_edit = payload
  },
  "SET_TOGGLE_MODAL_ADD_EDIT_DISCARD": (state, payload) => {
    state.toggle_modal_add_edit_discard = payload
  }
}

const actions = {
  async getDetailTermsCondition(context, payload) {
    try {
      context.commit('SET_DETAIL_TERMS_CONDITION', { isLoading: true })
      const response = await apiGetAuth(API_TERMS_CONDITION.LIST, payload)
      context.commit('SET_DETAIL_TERMS_CONDITION', {
        isLoading: false,
        data: response?.data?.data
      })
    } catch (error) {
      context.commit('SET_DETAIL_TERMS_CONDITION', {
        isLoading: false,
        data: {}
      })
      notificationDanger(error)
    }
  },
  async updateDetailTermsCondition(context, payload) {
    try {
      const response = await apiPutAuth(API_TERMS_CONDITION.BY_ID(payload.id), payload.reqBody)
      return response?.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      throw error
    }
  },
  async updateStatusTermsCondition(context, payload) {
    try {
      const response = await apiPostAuth(API_TERMS_CONDITION.UPDATE_TNC, payload)
      return response?.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      throw error
    }
  }
}

const getters = {
  get_detail_terms_condition: state => {
    return state.detail_terms_condition
  },
  get_data_modal_add_edit: state => {
    return state.data_modal_add_edit
  },
  get_toggle_modal_add_edit_discard: state => {
    return state.toggle_modal_add_edit_discard
  }
}

const namespaced = true
export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
